// extracted by mini-css-extract-plugin
module.exports = {"hamburger":"_2aMzB","navigationContainer":"_38xOW","label":"_2QynF","socialLinks":"j-IjA"};